import {
  BookOpen,
  Calculator,
  Camera,
  Code,
  Dumbbell,
  Globe,
  GraduationCap,
  HeartPulse,
  Languages,
  LucideIcon,
  Mic,
  Music,
  Palette,
  Star,
  Target,
  Trophy,
  Users,
} from "lucide-react";
import { BookingPageServiceIcon } from "../../features/trial-requests/enums/BookingPageServiceIcons";

/**
 * Explicit imports keep tree-shaking intact — never import lucide's full
 * `icons` map. Must cover every name in BOOKING_PAGE_SERVICE_ICONS.
 */
export const SERVICE_ICON_MAP: Record<BookingPageServiceIcon, LucideIcon> = {
  Music,
  Mic,
  BookOpen,
  GraduationCap,
  Languages,
  Dumbbell,
  HeartPulse,
  Palette,
  Camera,
  Code,
  Calculator,
  Globe,
  Users,
  Star,
  Target,
  Trophy,
};
